import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {SocialMediaMobileFooterPanelProps} from '@Panels/social-media-mobile-footer-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'social-media-mobile-footer-panel';
export type SocialMediaWizardMobileFooterModalProps = SocialMediaMobileFooterPanelProps;

export default function SocialMediaWizardMobileFooterModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SOCIAL_MEDIA_WIZARD_MOBILE_FOOTER_MODAL];
  });

  const height = 'auto';
  const width = '100%';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_MEDIA_WIZARD_MOBILE_FOOTER_MODAL} modalHeight={height} modalWidth={width} panelId={PANEL_ID}>
      <LazyPanel
        panelDirectoryName="social-media-mobile-footer-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSocialMediaMobileFooterModal = (props: SocialMediaWizardMobileFooterModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_MEDIA_WIZARD_MOBILE_FOOTER_MODAL,
      panelProps: props,
    })
  );
};
